import { Box, Typography } from "@mui/material";
import axios from "axios";
import { Component } from "react";
import { Modal } from "semantic-ui-react";
import { apiCall_domain } from "../api";
import PulseLoader from "react-spinners/PulseLoader";
class MyCar extends Component {
  state = {
    showConfirmDelete: false,
    loading: false,
  };
  deleteCar = (id) => {
    const headers = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    this.setState({ loading: true }, () => {
      axios
        .post(
          `${apiCall_domain}/customer/user/cars/delete`,
          { id },
          { headers: headers }
        )
        .then((res) => {
          this.props.getCars();
          this.setState({ loading: false, showConfirmDelete: false });
        });
    });
  };
  handleModal = () => {
    this.setState({ showConfirmDelete: !this.state.showConfirmDelete });
  };

  render() {
    const style = {
      borderRadius: "8px",
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      bgcolor: "background.paper",
      p: 4,
      width: "90%",
      padding: "14px",
    };
    const { index, car } = this.props;
    return (
      <div className='MyCarsList' key={index}>
        <div>
          <span className='CarNames'>{car.name}</span>
          <span className='text text--Company'>( {car.car.brand} )</span>
        </div>
        <div className='mycarsContent'>
          <div className='MyCarsType'>
            <span className='text text--type'>تیپ :</span>
            <span className='text text--type'>{car.car.type}</span>
          </div>
          <div>
            <span className='text text--type'> سازنده :</span>
            <span className='text text--type'> {car.car.brand}</span>
          </div>
        </div>
        <div className='MyCarsbottom'>
          <span>{car.car.name}</span>
          <button className='btn btn--remove' onClick={this.handleModal}>
            حذف خودرو
          </button>
          <Modal
            className='carDeleteConfirmation'
            open={this.state.showConfirmDelete}>
            <Box sx={style}>
              <Typography
                id='modal-modal-title'
                variant='h6'
                component='h2'
                sx={{ textAlign: "center", color: "2f363d" }}>
                حذف آدرس
              </Typography>
              <Typography id='modal-modal-description' sx={{ mt: 2 }}>
                آیا مایل به حذف این خودرو هستید؟
              </Typography>
              <Typography id='modal-modal-description' sx={{ mt: 3 }}>
                <button
                  className='btn btn--addres'
                  onClick={() => {
                    this.deleteCar(car.id);
                  }}>
                  {this.state.loading ? (
                    <PulseLoader color='#fff' size={12} />
                  ) : (
                    "بله"
                  )}
                </button>
                <button className='btn btn--delete' onClick={this.handleModal}>
                  خیر
                </button>
              </Typography>
            </Box>
          </Modal>
        </div>
      </div>
    );
  }
}

export default MyCar;
